<div class="o-grid component-container">
    <div class="o-grid__row">
        <div class="o-grid__item">
            <h3>Request History</h3>
        </div>
    </div>
    @if (requestHistoryPosts.value(); as posts) {
        <div class="post-container">
            @for (post of posts; track post) {
                <medpace-request-history-post [postInfo]="post" />
            }
        </div>
    }
</div>
